import run from '../../utilities/run';
import render from "../../utilities/render";
import {handleDisplayForV2} from '../../utilities/selectorHelpers';
import {setSwitchery,instantiateSwitchery, enableSwitchery, disableSwitchery} from '../../utilities/instantiateSwitchery';
import {isPresent, isTruthy, isFalsey, getMilitaryTimeFromDate, fuseDateTimeValueToStandard} from "../../utilities/general";
import $ from 'jquery';
import moment from "moment";
import _ from "underscore";
import {setOptionsForSelect , setElementsFromScope} from "../../utilities/selectorHelpers";
import { isUndefined } from 'util';
import timePicker from "../../components/timePicker";
const releaseTypeHtml = require("./html/orderReleaseType.html");

export default function PreparationTab(wizard) {

	//Shipping Tab
	const self = this;
	const elsPage = {};
	const wizardElement = wizard.getWizardElement();
	const elementsPageMap = {};
	const orderDetailsForEdit = wizardElement.data("edit-order-details");
	const orderCreatedDate =  wizardElement.data("order-create-date");
	const initialOrderGiftMessageInEdit = wizardElement.data("order-gift-message");
	const shippingTabOrdReleaseType = $("#shipping-tab-order-release-type");
	const gpHours = shippingTabOrdReleaseType.data("gp-hours");
	const gpMinutes = shippingTabOrdReleaseType.data("gp-minutes");
	const gracePeriod = shippingTabOrdReleaseType.data("grace-period");
	const channelGracePeriod = shippingTabOrdReleaseType.data("channel-grace-period");
	const isChannelOrder = wizardElement.data("is-channel-order");
	const orderReleaseType = shippingTabOrdReleaseType.data('options');
	const viewOrderPackagingDetail = $('#create-order-form').data('view-order-packaging-detail-url');
	const orderPkgDetailLink = $('.order-pkg-detail-link');
	const serviceCenterHelpURL =  $("#create-order-form").data("service-center-help-url");
	const createOrderHelpCenterURL =  $("#create-order-form").data("create-order-help-center-url");
	const helpCenterButton = $("#create-order-form").find("#helpCenterUrl");
	const createOrderHelpCenterButton = $("#create-order-form").find("#createOrderHelpUrl");
	const getShipmentMethodsUrl = $('#create-order-form').data('get-shipment-methods-url');
	const getServiceLevelsUrl = $('#create-order-form').data('get-service-levels-url');
	const declaredValueDiv = $("#declared-value-div");
	const isDVLValueSet = declaredValueDiv.data("is-set-in-order-config");
	const shipmentMethodsToExcludeDVL = declaredValueDiv.data("shipment-methods-to-exclude-for-dvl");
	const declaredValueCheckbox = $("#declared-value-checkbox");
	const dateFormat = "MM/DD/YYYY";
	const datTimeFormat = "MM/DD/YYYY hh:mm A";
  const shippingTypeHidden = $("#shipping-type-hidden");

	if(_(orderDetailsForEdit).isEmpty() && isDVLValueSet) {
		declaredValueCheckbox.prop("checked",true);
	} else {
		declaredValueCheckbox.prop("checked",false);
	}

	const shipmentAccessorialMap= $('#create-order-form').data('shipment-method-accessorial');
	const uniqueShipmentArray = _.chain(shipmentAccessorialMap).map(function(accessorial) { return accessorial.accessorial_code}).uniq().value();

	const serviceLevelsAccessorialMap= $('#create-order-form').data('service-levels-method-accessorial');
	const uniqueServiceLevelArray = _.chain(serviceLevelsAccessorialMap).map(function(accessorial) { return accessorial.accessorial_code}).uniq().value();

	const allValidShipServiceLevels = uniqueShipmentArray.concat(uniqueServiceLevelArray);

	const fedexShippingMethodBtn = $(".fedex-shipping-method-btn");
	const serviceLevelsBtn = $(".service-levels-btn");

	const fedexShippingMethodBtnValueCheck = $("#fedex-shipping-method-btn-value-check");
	 const serviceLevelsBtnValueCheck = $("#service-levels-btn-value-check");

	//7775 Changes START


	const shippingTabAccessorialeNote = $("#shipping-tab-accessorials-signature");
	const accessorialsSignature = $("#shipping-tab-accessorials-signature");
	const signatureOptionsSelect=$("#signature-options-select");
	const saturdayDeliveryCheckbox=$("#saturday-delivery-checkbox");
	saturdayDeliveryCheckbox.on("change", populateSaturdayDelivery);

	const shippingTabOrdReleaseNote = $("#shipping-tab-order-release-note");
	const shippingTabOrdRelease = $("#shipping-tab-order-release");
	const shippingTabScheduleRelease = $("#shipping-tab-schedule-release");

	const shippingMethodDropDown =  $("#shipping-tab-shipping-method-with-usa");
	shippingMethodDropDown.on("change", populateShippingAccessorialValues);

	const serviceLevelsDropDown =  $("#shipping-tab-shipping-service-level-with-usa");
	serviceLevelsDropDown.on("change", populateServiceAccessorialValues);

	const shippingMethodCanadaDropDown = $("#shipping-tab-shipping-method-with-canada");
	shippingMethodCanadaDropDown.on("change", populateCanadaShippingAccessorialValues);

	const shippingMethodOtherDropDown = $("#shipping-tab-shipping-method-other");
	shippingMethodOtherDropDown.on("change", populateOtherShippingAccessorialValues);

	const retainChannelShipmentMethodSwitch = $("#channelShippingMethodCheck");
	instantiateSwitchery(retainChannelShipmentMethodSwitch, {});
	retainChannelShipmentMethodSwitch.on("change", handleRetainChannelShipmentMethod);


	saturdayDeliveryCheckbox.prop("checked", false);
	saturdayDeliveryCheckbox.prop("disabled", true);
	saturdayDeliveryCheckbox.val("");

	let closestEl =  signatureOptionsSelect.data('target-closest');
	let closestParentEl = signatureOptionsSelect.closest(closestEl);
	function handleSignatureOptionEnable(el) {
		signatureOptionsSelect.attr("disabled", false);
		el.find(".select2-container").css("pointer-events",'');

	}
	function handleSignatureOptionDisable(el) {
		signatureOptionsSelect.attr("disabled", true);
		el.find(".select2-container").css("pointer-events",'none');

	}

	const shippingTypeDropDown = $("#shipping-tab-shipping-type-select");
	let closestShippingTypeEl =  shippingTypeDropDown.data('target-closest');
	let closestShippingTypeParentEl = shippingTypeDropDown.closest(closestShippingTypeEl);
	function handleShippingTypeEnable(el) {
		shippingTypeDropDown.attr("disabled", false);
		el.find(".select2-container").css("pointer-events",'');

	}
	function handleShippingTypeDisable(el) {
		shippingTypeDropDown.attr("disabled", true);
		el.find(".select2-container").css("pointer-events",'none');
	}

	function handleRetainChannelShipmentMethod() {
    const orderDetails = orderDetailsForEdit.orderDetails;
        if(retainChannelShipmentMethodSwitch.is(":checked") ){
			setSwitchery(retainChannelShipmentMethodSwitch, true);
			handleShippingTypeDisable(closestShippingTypeParentEl);
			wizardElement.find(".retainShippingMethod").removeClass("hidden");
			wizardElement.find("#channel-shipping-method").val(orderDetails.ordShippingMethod);
			wizardElement.find(".shipping-method-div").addClass("hidden");
			wizardElement.find("#shipping-tab-parcel-msg").addClass("hidden");
			wizardElement.find("#shipping-tab-shipping-method-with-usa-wrapper-selection").hide();
			wizardElement.find("#shipping-tab-service-level-with-usa-wrapper-selection").hide();
			wizardElement.find("#shipping-tab-service-level-estimated-date").hide();
			wizardElement.find(".estimated-delivery-date-message").hide();
			//Accessorials are read only for Channel the first time
			loadAccessoraialsForChannel(orderDetails);
        } else {
			setSwitchery(retainChannelShipmentMethodSwitch, false);
			handleShippingTypeEnable(closestShippingTypeParentEl);
			wizardElement.find(".retainShippingMethod").addClass("hidden");
			wizardElement.find(".shipping-method-div").removeClass("hidden");
			wizardElement.find("#shipping-tab-parcel-msg").removeClass("hidden");
			fedexShippingMethodBtn.removeClass("active");
			fedexShippingMethodBtnValueCheck.val("false");
			serviceLevelsBtn.removeClass("active");
			serviceLevelsBtnValueCheck.val("false");
			shippingMethodDropDown.val("-1").trigger("change.select2");
			serviceLevelsDropDown.val("-1").trigger("change.select2");
        }
	}

	let date = new Date();
	let enddate = new Date();
	enddate.setDate(enddate.getDate() + 30);
	$('#scheduleReleaseDate').datepicker({
		todayBtn: "linked",
        startDate: date,
		endDate: enddate,
        keyboardNavigation: false,
        forceParse: false,
        calendarWeeks: false,
        autoclose: true
    }).on("changeDate", function (e) {
		$('#scheduleReleaseDate').trigger('blur');
	});

	let scheduleReleaseDateVal;

	const scheduledReleaseTimePickerEl = $('.scheduled-release-time-picker');
	let scheduledReleaseTimePicker = timePicker(scheduledReleaseTimePickerEl);

    let estimatedDeliveryDatePicker = $('.estimated-delivery-date-picker');
    estimatedDeliveryDatePicker.datepicker({
      startDate: '+1d',
      keyboardNavigation: true,
      autoclose: true
	});


	function populateOtherShippingAccessorialValues() {
		loadAccessorialSectionValues(shippingMethodOtherDropDown.val(),shipmentAccessorialMap);
		$('#signature-options-select').trigger('change');
	}

	function populateCanadaShippingAccessorialValues() {
		loadAccessorialSectionValues(shippingMethodCanadaDropDown.val(),shipmentAccessorialMap);
		$('#signature-options-select').trigger('change');
	}

	function populateShippingAccessorialValues() {
		loadAccessorialSectionValues(shippingMethodDropDown.val(),shipmentAccessorialMap);
		$('#signature-options-select').trigger('change');
	}

	function populateServiceAccessorialValues() {
		loadAccessorialSectionValues(serviceLevelsDropDown.val(),serviceLevelsAccessorialMap);
		$('#signature-options-select').trigger('change');
	}
	function populateSaturdayDelivery() {
		if($(this).prop("checked") == true){
			saturdayDeliveryCheckbox.val("SAT");
		}
		else if($(this). prop("checked") == false) {
			saturdayDeliveryCheckbox.val("");
		}
	}


	function loadAccessorialSectionValues(shipmentServiceValue, accessorialMap) {
		signatureOptionsSelect.empty();
		handleSignatureOptionDisable(closestParentEl);

		saturdayDeliveryCheckbox.prop("checked", false);
		saturdayDeliveryCheckbox.val("");

		let value=shipmentServiceValue;

		if(_(shipmentMethodsToExcludeDVL).contains(value)){
			declaredValueCheckbox.prop("checked", false);
			declaredValueCheckbox.prop("disabled",true);
		} else {
			declaredValueCheckbox.prop("disabled",false);
		}

		let selectedValues = [];
		$.each(accessorialMap, function(index) {
			if(accessorialMap[index].accessorial_code == value) {
				selectedValues.push(accessorialMap[index]);
			}
		});


		const checkboxDisabled = false;
		const defaultOption = $('<option /\>');
		defaultOption.attr('value', "-1").text("Select signature option");
		signatureOptionsSelect.append(defaultOption);

		$.each(selectedValues, function(index, selectedValue) {
			//Signature validation
			if(selectedValues[index].accessorial_code==value && selectedValues[index].accessorial_object.cdmMeaning =='Y'
				&& selectedValues[index].accessorial_object.cdmDescription != "Saturday Delivery") {
				handleSignatureOptionEnable(closestParentEl);
				const option = $('<option /\>');
				option.attr('value', selectedValue.accessorial_object.cdmValue).text(selectedValue.accessorial_object.cdmDescription);
				signatureOptionsSelect.append(option);
			}
			//check box validation
			if(selectedValues[index].accessorial_code==value && selectedValues[index].accessorial_object.cdmMeaning=='N') {
				saturdayDeliveryCheckbox.attr("disabled",true);
				saturdayDeliveryCheckbox.hide();
			}
			else {
				saturdayDeliveryCheckbox.show();
				saturdayDeliveryCheckbox.attr("disabled",false);
			}
		});
		// For Fedex Smart post there is going to be no value in the signature drop down
		if(signatureOptionsSelect.find('option').length == 1) {
			handleSignatureOptionDisable(closestParentEl);
		}
	}

	$("#signature-options-select").change(function(e) {
		const accessorialValue = $("#signature-options-select option:selected").text();;
		if(accessorialValue == "Direct Signature Required") {
			accessorialsSignature.show();
			shippingTabAccessorialeNote.html("Signature from someone at delivery address.");
		} else if(accessorialValue == "Adult Signature Required") {
			accessorialsSignature.show();
			shippingTabAccessorialeNote.html("Signature from someone at least 21 years old at the delivery address. Government issued photo ID required.");
		} else {
			shippingTabAccessorialeNote.html("");
		}
	});

	shippingTabOrdReleaseType.on("change", handleOrdReleaseChange);



	//7775 Changes END

	function loadAccessorialSectionValuesForEdit(shipmentServiceValue, accessorialMap, orderDetails) {
		signatureOptionsSelect.empty();
		handleSignatureOptionDisable(closestParentEl);
		saturdayDeliveryCheckbox.prop("checked", false);
		saturdayDeliveryCheckbox.val("");

		let shipmentServiceAccessorialValues = [];
		//Set the Declared Value if available in the Order
		if((!_(shipmentMethodsToExcludeDVL).contains(shipmentServiceValue)) && isTruthy(orderDetails.ordDvl)) {
			declaredValueCheckbox.prop("checked", true);
			declaredValueCheckbox.prop("disabled",false);
		} else {
			declaredValueCheckbox.prop("checked", false);
		}

		$.each(accessorialMap, function(index) {
			if(accessorialMap[index].accessorial_code == shipmentServiceValue) {
				shipmentServiceAccessorialValues.push(accessorialMap[index]);
			}
		});
		const defaultOption = $('<option /\>');
		defaultOption.attr('value', "-1").text("Select signature option");
		signatureOptionsSelect.append(defaultOption);

		$.each(shipmentServiceAccessorialValues, function(index, selectedValue) {
			//Signature validation
			if(shipmentServiceAccessorialValues[index].accessorial_code == shipmentServiceValue && shipmentServiceAccessorialValues[index].accessorial_object.cdmMeaning =='Y'
				&& shipmentServiceAccessorialValues[index].accessorial_object.cdmDescription != "Saturday Delivery") {
				handleSignatureOptionEnable(closestParentEl);
				const option = $('<option /\>');
				option.attr('value', selectedValue.accessorial_object.cdmValue).text(selectedValue.accessorial_object.cdmDescription);
				signatureOptionsSelect.append(option);
			}
			//check box validation
			if(shipmentServiceAccessorialValues[index].accessorial_code == shipmentServiceValue && shipmentServiceAccessorialValues[index].accessorial_object.cdmMeaning=='N') {
				saturdayDeliveryCheckbox.attr("disabled",true);
				saturdayDeliveryCheckbox.hide();
			}
			else {
				saturdayDeliveryCheckbox.show();
				saturdayDeliveryCheckbox.attr("disabled",false);
			}
		});

		//Set the signature option to the one recieved from the Order
		if(isPresent(orderDetails.ordSignatureOption)) {
			let selectedSignatureValue;
			let currentShipmentMethod = orderDetails.ordShippingMethod;
			if(orderDetails.ordSignatureOption === "COS") {
				//Direct Signature
				selectedSignatureValue = currentShipmentMethod+"_DIRECT";
			} else if(orderDetails.ordSignatureOption === "COA") {
				//Adult Signature
				selectedSignatureValue = currentShipmentMethod+"_ADULT";
			}

			signatureOptionsSelect.val(selectedSignatureValue).trigger("change.select2");
			signatureOptionsSelect.trigger("change");
		}

		//Set the saturday delivery check box if present
		if(orderDetails.ordSaturdayDelivery == "SAT") {
			saturdayDeliveryCheckbox.prop("checked", true);
			saturdayDeliveryCheckbox.trigger("change");
		}
	}

	self.init = function() {
		setElements();
		if(!_(orderDetailsForEdit).isEmpty()) {
			fillShippingTabForEdit(orderDetailsForEdit);
		}

	};

	self.getScheduleReleaseTimeAndDate = function() {
		let scheduleDateAndTime, scheduleReleaseTimeVal;
		scheduleReleaseDateVal =  $('#scheduleReleaseDate').val();
		scheduleReleaseTimeVal = scheduledReleaseTimePicker.getMilitaryTime();
		if(scheduleReleaseTimeVal == "Invalid date") {
			let isBefore = moment(scheduleReleaseDateVal, dateFormat).isBefore(new Date());
			//If current date 11:59 PM
			if(isBefore) {
				scheduleReleaseTimeVal = "23:59";
			} else {
				scheduleReleaseTimeVal = "00:00";
			}//Else, when its future date 00:00 AM

		}
		scheduleDateAndTime = fuseDateTimeValueToStandard(scheduleReleaseDateVal,scheduleReleaseTimeVal);
		$("#standardDateAndTime").val(moment(scheduleDateAndTime).format(datTimeFormat));

	}

	self.checkIfDateTimeInPast = function() {
		const orderTypeValue = shippingTabOrdReleaseType.find(':selected').val();
		if(orderTypeValue == "Scheduled Release") {
			scheduleReleaseDateVal =  $('#scheduleReleaseDate').val();
			let scheduleDateAndTime = fuseDateTimeValueToStandard(scheduleReleaseDateVal, scheduledReleaseTimePicker.getMilitaryTime());
			let isBefore = moment(scheduleDateAndTime).isBefore(new Date());
			return isBefore;
		} else {
			return false;
		}
		
	}


	function loadOrderReleaseType(wizardElement, orderDetails) {
		let orderActualGracePeriod, scheduledDate , currentDate;
		let isScheduleDateExpired;
		if(isPresent(orderDetails.ordCreatedDate) && isPresent(orderDetails.ordGracePeriod) && orderDetails.ordGracePeriod != 0) {
			orderActualGracePeriod = moment(orderCreatedDate, datTimeFormat).add(orderDetails.ordGracePeriod, 'm');
			scheduledDate = moment(orderActualGracePeriod).format(dateFormat);
			let timePickerValue = moment(orderActualGracePeriod);
			let hoursMinutesValue = getMilitaryTimeFromDate(timePickerValue._d);
			scheduledReleaseTimePicker.setTimeFromMilitary(hoursMinutesValue);
			let dateTimeSchDate = moment(orderActualGracePeriod).format(datTimeFormat);
			currentDate  = moment(new Date()).format(datTimeFormat);
			(currentDate > dateTimeSchDate) ? isScheduleDateExpired = true: isScheduleDateExpired =false;
		}


		//If Release type present it is manual order, retain the Release type if Hold Indefinitely/ Release Immediately
		// If Grace period expired then set to Release Immeditely else Sched
		// Else for Channel orders, check the grace period if expired

		if(isPresent(orderDetails.ordReleaseType)) {
			if(orderDetails.ordReleaseType == 'Release Immediately' || orderDetails.ordReleaseType == 'Hold Indefinitely' ) {
				wizardElement.find("#shipping-tab-order-release-type").val(orderDetails.ordReleaseType).trigger("change.select2");
			} else {
					if(isTruthy(isScheduleDateExpired)) {
						wizardElement.find("#shipping-tab-order-release-type").val("Release Immediately").trigger("change.select2");
					} else {
						wizardElement.find("#shipping-tab-order-release-type").val("Scheduled Release").trigger("change.select2");
						$('#scheduleReleaseDate').val(scheduledDate).trigger("change");

					}
			}

		} else {
			if(isTruthy(isScheduleDateExpired)) {
				wizardElement.find("#shipping-tab-order-release-type").val("Release Immediately").trigger("change.select2");
			} else {
				wizardElement.find("#shipping-tab-order-release-type").val("Scheduled Release").trigger("change.select2");
				$('#scheduleReleaseDate').val(scheduledDate).trigger("change");;
			}
		}

		wizardElement.find("#shipping-tab-order-release-type").trigger("change");
	}

	function loadAccessoraialsForChannel(orderDetails) {
		if(isTruthy(orderDetails.ordDvl)) {
			declaredValueCheckbox.prop("checked", true);
			declaredValueCheckbox.prop("disabled",true);
		}

		if(isPresent(orderDetails.ordSignatureOption)) {
			handleSignatureOptionDisable(closestParentEl);
			const defaultOption = $('<option value ="-1">Select signature option</option>');
			signatureOptionsSelect.append(defaultOption);
			const directOption = $('<option value ="DEFAULT_DIRECT">Direct Signature Required</option>');
			signatureOptionsSelect.append(directOption);
			const adultOption = $('<option value ="DEFAULT_ADULT">Adult Signature Required</option>');
			signatureOptionsSelect.append(adultOption);

			let selectedSignatureValue;
			let currentShipmentMethod = orderDetails.ordShippingMethod;
			if(orderDetails.ordSignatureOption === "COS") {
				//Direct Signature
				selectedSignatureValue = "DEFAULT_DIRECT";
			} else if(orderDetails.ordSignatureOption === "COA") {
				//Adult Signature
				selectedSignatureValue = "DEFAULT_ADULT";
			}
			signatureOptionsSelect.val(selectedSignatureValue).trigger("change.select2");
			signatureOptionsSelect.trigger("change");
		} else {
			handleSignatureOptionDisable(closestParentEl);
			const defaultOption = $('<option value ="-1">Select signature option</option>');
			signatureOptionsSelect.append(defaultOption);
			signatureOptionsSelect.val("-1").trigger("change.select2");
			signatureOptionsSelect.trigger("change");

		}
		if(orderDetails.ordSaturdayDelivery == "SAT") {
			saturdayDeliveryCheckbox.prop("checked", true);
			saturdayDeliveryCheckbox.prop("disabled",true);
			saturdayDeliveryCheckbox.trigger("change");
		} else {
			saturdayDeliveryCheckbox.prop("checked", false);
			saturdayDeliveryCheckbox.prop("disabled",true);
			saturdayDeliveryCheckbox.trigger("change");
		}
	}


	function fillShippingTabForEdit(orderDetailsForEdit) {
		const orderDetails = orderDetailsForEdit.orderDetails;
		let shipmentMethod = orderDetails.ordShippingMethod;
		if(!_(shipmentMethod).isEmpty()) {
			if(_(allValidShipServiceLevels).contains(shipmentMethod)) {
				if(retainChannelShipmentMethodSwitch.length > 0) {
					setSwitchery(retainChannelShipmentMethodSwitch, false);
					disableSwitchery(retainChannelShipmentMethodSwitch);
				}
				//hide the shipping method text box
				wizardElement.find(".retainShippingMethod").hide();
				wizardElement.find(".shipping-method-div").show();
				if(_(uniqueShipmentArray).contains(shipmentMethod)) {
					//active shipping method toggle
					fedexShippingMethodBtn.addClass("active");
					fedexShippingMethodBtn.trigger("click");
					fedexShippingMethodBtnValueCheck.val("true");
					serviceLevelsBtn.removeClass("active");
					serviceLevelsBtnValueCheck.val("false");
					loadAccessorialSectionValuesForEdit(shipmentMethod, shipmentAccessorialMap, orderDetails);

				} else if(_(uniqueServiceLevelArray).contains(shipmentMethod)){
					//active service level toggle
					serviceLevelsBtn.addClass("active");
					serviceLevelsBtn.trigger("click");
					serviceLevelsBtnValueCheck.val("true");
					fedexShippingMethodBtn.removeClass("active");
					fedexShippingMethodBtnValueCheck.val("false");
					loadAccessorialSectionValuesForEdit(shipmentMethod, serviceLevelsAccessorialMap, orderDetails);
				}
 			} else {
				wizardElement.find("#channel-shipping-method").val(orderDetails.ordShippingMethod);
				if(retainChannelShipmentMethodSwitch.length > 0) {
					retainChannelShipmentMethodSwitch.removeAttr("disabled");
					setSwitchery(retainChannelShipmentMethodSwitch, true);
					retainChannelShipmentMethodSwitch.trigger("change");
				}
				wizardElement.find(".shipping-method-div").addClass("hidden");
				wizardElement.find("#shipping-tab-parcel-msg").addClass("hidden");
				//Accessorials are read only for Channel the first time
				loadAccessoraialsForChannel(orderDetails);

			}
		}
		if(isPresent(orderDetails.ordFreightCost)) {
			wizardElement.find("#freight-costs").val(orderDetails.ordFreightCost);
		}
		if(isPresent(orderDetails.ordInsuranceCost)){
			wizardElement.find("#insurance-costs").val(orderDetails.ordInsuranceCost);
		}
		if(isPresent(orderDetails.ordDutiesTaxes)){
			wizardElement.find("#duties-taxes").val(orderDetails.ordDutiesTaxes);
		}

		//If Order Has Estimated Delivery Date Populate the value
		if(isPresent(orderDetails.ordEstDlvyDate)) {
			$('.estimated-delivery-date-picker').val((moment(orderDetails.ordEstDlvyDate).format(dateFormat)));
		}

		//Set the Order Release Type
		loadOrderReleaseType(wizardElement, orderDetails);

		//Set the Shipping Type
		wizardElement.find("#shipping-tab-shipping-type-select").val(orderDetails.ordShippingType);
    shippingTypeHidden.val(orderDetails.ordShippingType);
		wizardElement.find("#shipping-tab-shipping-type-select").trigger("change");

		//Set the Alternate Packing Value if available in the Order
		if(orderDetails.ordAlternatePackagingReq) {
				wizardElement.find("#bulk-packaging").prop("checked", true);
		} else {
				wizardElement.find("#bulk-packaging").prop("checked", false);
		}

		//Set the Collateral Value if available in the Order
		if(orderDetails.ordExcludeCollateral) {
				wizardElement.find("#exclude-collateral").prop("checked", true);
		} else {
				wizardElement.find("#exclude-collateral").prop("checked", false);
		}

		//Set the Gift message turned on if available in the Order
		wizardElement.find("#gift-textarea").val(initialOrderGiftMessageInEdit);
	}

	function setElements() {
		setElementsFromScope(elsPage, elementsPageMap, wizardElement);
		handleShippingTypeEnable(closestShippingTypeParentEl);
	 }


	$(helpCenterButton).on('click', function(){
		window.open(serviceCenterHelpURL);
	});

	$(createOrderHelpCenterButton).on('click', function(){
		window.open(createOrderHelpCenterURL);
	});

	$(orderPkgDetailLink).on("click", function(e) {
			$.ajax({
			url: viewOrderPackagingDetail,
			type: 'POST',
			success: function(data){
				{
					window.open(data,'OrderPackaging');

				}
			}
		});
	});

	shippingTabOrdReleaseType.append(generateOrderReleaseTypeOptions(orderReleaseType));

	function generateOrderReleaseTypeOptions(ordRelType){
		let orderReleaseTypeOptionsHtml = ordRelType.map((relType)=>{
			const scheduleReleaseTogglerTarget = (relType == 'Scheduled Release') ? '#shipping-tab-schedule-release' : '#shipping-tab-order-release' ;
			const ifInternalOrd = ((relType == 'Internal Order Grace Period') && gpHours == 0 && gpMinutes == 0) ? 'disabled' : '';
			return render(`<option value='{%- value %}' data-quick-toggler-target='{%- target %}' {%- isDisabled %}>{%- value %}</option>`,{
				value: relType,
				target: scheduleReleaseTogglerTarget,
				isDisabled: ifInternalOrd
			});
		});
		return orderReleaseTypeOptionsHtml.join('');
	}

	const shippingTypeSelect = $("#shipping-tab-shipping-type-select");
	const shippingTypeList = shippingTypeSelect.data('options');

	$(shippingTypeList).each(function(){
		const option = $('<option />');
			option.attr('value', this.cdmValue).text(this.cdmMeaning);
		shippingTypeSelect.append(option);
	});

	const destTabOrderType = $("#destination-tab-order-type-select");
	const destTabDropShipFlag = $("#dropShipFlag");
	const giftNoteSection = $(".gift-note-section");
	const giftCheckboxTogglable = $(".gift-checkbox-togglable");
	const shippingTabIsAGiftCheckbox = $("#gift-checkbox");
	const shippingTabGiftTextArea = $("#gift-textarea");



	destTabOrderType.on("change", handleDestTabOrderTypeChange);
	destTabDropShipFlag.on("change", handleDestTabOrderTypeChange);
	shippingTypeSelect.on("change", handleShippingTypeChange);
	handleGiftNoteSectionDisplay();
	calcShippingMethod();


	self.handleDestTabOrderTypeLoad = function () {
		const serviceLevelsUsaId = $("#shipping-tab-shipping-service-level-with-usa");
		const shippingMethodUsaId = $("#shipping-tab-shipping-method-with-usa");
		const shippingCanadaId = $("#shipping-tab-shipping-method-with-canada");
		const shippingOtherId = $("#shipping-tab-shipping-method-other");
		let currentCountryValOnDestinationTab = $('#destination-tab-country  :selected').val();
		const orderDetails = (isPresent(orderDetailsForEdit.orderDetails)) ? (orderDetailsForEdit.orderDetails) : null;
		let shippingMethod = null;
		if (isPresent(orderDetails)) {
			shippingMethod = orderDetails.ordShippingMethod;
		}

		//If Selected Country Code is US
		if (currentCountryValOnDestinationTab == "-1" || currentCountryValOnDestinationTab == "1") {
			if (!_(shippingMethod).isEmpty()) {
				if (_(uniqueShipmentArray).contains(shippingMethod)) {
					let shippingOptionsSelected = shippingMethodUsaId.find("option");
					let shippingValArr = _(shippingOptionsSelected).pluck('value');
					if(_(shippingValArr).contains(shippingMethod)) {
						shippingMethodUsaId.val(shippingMethod).trigger("change.select2");
						shippingMethodUsaId.trigger("change");
						loadAccessorialSectionValuesForEdit(shippingMethod, shipmentAccessorialMap, orderDetails);
					} else {
						resetAccessorialSection() ;
					}

				} else if (_(uniqueServiceLevelArray).contains(shippingMethod)) {
					let serviceOptionsSelected = serviceLevelsUsaId.find("option");
					let serviceValArr = _(serviceOptionsSelected).pluck('value');
					if(_(serviceValArr).contains(shippingMethod)) {
						serviceLevelsUsaId.val(shippingMethod).trigger("change.select2");
						serviceLevelsUsaId.trigger("change");
						loadAccessorialSectionValuesForEdit(shippingMethod, serviceLevelsAccessorialMap, orderDetails);
					} else {
						resetAccessorialSection();
					}
				}
			} else {
				let shippingMethodValue = $('#shipping-tab-shipping-method-with-usa  :selected').val();
				let shippingServiceValue = $('#shipping-tab-shipping-service-level-with-usa  :selected').val();
				if (shippingMethodValue === "-1" && shippingServiceValue === '-1') {
					handleDestTabOrderTypeChange();
				}
			}
		} else if (currentCountryValOnDestinationTab == "2") {
			//If Selected Country Code is Canada 
			let shippingOptionsSelected = shippingCanadaId.find("option");
			let shippingValArr = _(shippingOptionsSelected).pluck('value');
			if(_(shippingValArr).contains(shippingMethod)) {
				shippingCanadaId.val(shippingMethod).trigger("change.select2");
				shippingCanadaId.trigger("change");
				loadAccessorialSectionValuesForEdit(shippingMethod, shipmentAccessorialMap, orderDetails);
			} else {
				resetAccessorialSection() ;
			}
		
		} else {
				//If Selected Country Code is Other than US/Canada
			let shippingOptionsSelected = shippingOtherId.find("option");
			let shippingValArr = _(shippingOptionsSelected).pluck('value');
			if(_(shippingValArr).contains(shippingMethod)) {
				shippingOtherId.val(shippingMethod).trigger("change.select2");
				shippingOtherId.trigger("change");
				loadAccessorialSectionValuesForEdit(shippingMethod, shipmentAccessorialMap, orderDetails);
			} else {
				resetAccessorialSection() ;
			}
		}
	}

	
	function handleDestTabOrderTypeChange(){
		handleGiftNoteSectionDisplay();
		loadShipmentMethods(destTabOrderType.val(), destTabDropShipFlag.prop("checked"));
		loadServiceLevels(destTabOrderType.val(), destTabDropShipFlag.prop("checked"));
	}

	function handleGiftNoteSectionDisplay(){
		const isB2C = isOrderTypeB2C(destTabOrderType.val(), destTabDropShipFlag.prop("checked"))
		handleDisplayForV2(giftNoteSection, isB2C);
		handleDisplayForV2(giftCheckboxTogglable, isB2C);
		//reset checkbox and message
		if (!isB2C) {
			shippingTabIsAGiftCheckbox.prop("checked", false);
			shippingTabGiftTextArea.val("");
		}
	}

	function isOrderTypeB2C(orderType, dropShipFlag){
		if (orderType === 'B2C' || (orderType !== 'B2B' && dropShipFlag)) {
			return true
		}
		return false
	}

	function handleShippingTypeChange(){
		calcShippingMethod();
	}

	function loadShipmentMethods(orderType, dropShipFlag){
			$.ajax({
			url: getShipmentMethodsUrl,
			type: 'POST',
			dataType: 'JSON',
			data: { orderType, dropShipFlag },
			success: function(data){
				const shippingMethodUsaId = $("#shipping-tab-shipping-method-with-usa");
				shippingMethodUsaId.empty();
				const option = $('<option /\>');
				option.attr('value', "-1").text("Please select shipping method");
				option.attr('disabled', 'disabled')
				option.attr('selected', 'selected')
				shippingMethodUsaId.append(option);
				$.each(data, function(index, value) {
						const option = $('<option /\>');
						option.attr('value', value.cdmValue).text(value.cdmMeaning);
						shippingMethodUsaId.append(option);
				});
			}
		});
	}

	function loadServiceLevels(orderType, dropShipFlag){
			$.ajax({
			url: getServiceLevelsUrl,
			type: 'POST',
			dataType: 'JSON',
			data: { orderType, dropShipFlag },
			success: function(data){
				if(data.length > 0){
					const serviceLevelsUsaId = $("#shipping-tab-shipping-service-level-with-usa");
					serviceLevelsUsaId.empty();
					const option = $('<option /\>');
					option.attr('value', "-1").text("Select from Service Levels");
					option.attr('disabled', 'disabled')
					option.attr('selected', 'selected')
					serviceLevelsUsaId.append(option);
					$.each(data, function(index, value) {
							const option = $('<option /\>');
							option.attr('value', value.cdmValue).text(value.cdmMeaning);
							serviceLevelsUsaId.append(option);
					});
				}else{
					const serviceLevelsUsaId = $("#shipping-tab-shipping-service-level-with-usa");
					serviceLevelsUsaId.empty();
				}
			}
		});
	}

	function handleOrdReleaseChange() {
		const orderTypeValue = shippingTabOrdReleaseType.find(':selected').val();
		if(orderTypeValue == "Internal Order Grace Period") {
			if(_(orderDetailsForEdit).isEmpty()) {
				shippingTabOrdReleaseNote.html(`Order will be released in <b>${gpHours} hrs ${gpMinutes} mins</b>.`);
			} else {
				const datTimeFormat = "MM/DD/YYYY hh:mm A";
				const orderDetails = orderDetailsForEdit.orderDetails;
				let oriGracePeriod;
				if(!_(orderDetails.ordGracePeriod).isEmpty()) {
					oriGracePeriod = orderDetails.ordGracePeriod;
				} else {
					if(isTruthy(isChannelOrder)) {
						oriGracePeriod = channelGracePeriod;
					} else {
						oriGracePeriod = gracePeriod;
					}

				}

				let scheduledReleaseDate = moment(orderDetailsForEdit.orderDetails.orderCreatedDate).add(oriGracePeriod, 'm');
				let scheduledRelease = moment(scheduledReleaseDate).format(datTimeFormat) + " ET";
				shippingTabOrdReleaseNote.html(render(releaseTypeHtml, {
					orderScheduledReleaseTimePeriod: scheduledRelease
				}));
			}

		}
		else if(orderTypeValue == "Release Immediately") {
			shippingTabOrdReleaseNote.html("Order will be released when submitted.");
		}
		else if(orderTypeValue == "Hold Indefinitely") {
			shippingTabOrdReleaseNote.html("Order must be manually released.");
		}
	}

	const shippingMethodCanadaId = $("#shipping-tab-shipping-method-with-canada");
	const shippingMethodCanadaList = shippingMethodCanadaId.data('options');
	$.each(shippingMethodCanadaList, function(index, value) {
			const option = $('<option /\>');
			option.attr('value', value.cdmValue).text(value.cdmMeaning);
			shippingMethodCanadaId.append(option);
	});

	const shippingMethodOtherId = $("#shipping-tab-shipping-method-other");
	const shippingMethodOtherList = shippingMethodOtherId.data('options');
	$.each(shippingMethodOtherList, function(index, value) {
			const option = $('<option /\>');
			option.attr('value', value.cdmValue).text(value.cdmMeaning);
			shippingMethodOtherId.append(option);
	});

};

export function calcShippingMethod() {
	let self = this;
	const fedexShippingMethodBtn = $(".fedex-shipping-method-btn");
	const serviceLevelsBtn = $(".service-levels-btn");
	const fedexShippingMethodBtnValueCheck = $("#fedex-shipping-method-btn-value-check");
	const serviceLevelsBtnValueCheck = $("#service-levels-btn-value-check");
  	const state = $('#destination-tab-state  :selected').val();
	const countryVal = $('#destination-tab-country  :selected').val();
	const shippingType = $('#shipping-tab-shipping-type-select :selected').val();
	const selectMethod = $(".select-method");
	const shippingMethodUsa = $("#shipping-tab-shipping-method-with-usa-wrapper");
	const shippingMethodCanada = $("#shipping-tab-shipping-method-with-canada-wrapper");
	const shippingMethodOther = $("#shipping-tab-shipping-method-other-wrapper");
	const internationalProductShippingCost = $("#international-product-shipping-cost");
	const shippingMethodLtlMsg = $("#shipping-tab-ltl-msg");
	const shippingMethodUsaSelect =$("#shipping-tab-shipping-method-with-usa-wrapper-selection");
	const shippingMethodParcelMsg = $("#shipping-tab-parcel-msg");
	const serviceLevelUsaSelect =$("#shipping-tab-service-level-with-usa-wrapper-selection");
	const estimatedDeliveryDate = $("#shipping-tab-service-level-estimated-date");
 	const serviceLevelsMessage = $(".estimated-delivery-date-message");
 	const dontShowSectionForParcelSelection =$(".dont-show-for-parcel-selection");
 	const dontShowSectionForLtlSelection =$(".hide-for-ltl-selection");
	const serviceLevelsUsaId = $("#shipping-tab-shipping-service-level-with-usa");
	const shippingMethodUsaId = $("#shipping-tab-shipping-method-with-usa");
	let btnClickVar=false;
	const signatureOptionsSelect = $("#signature-options-select");
	const saturdayDeliveryCheckbox = $("#saturday-delivery-checkbox");
  const shippingTypeHidden = $("#shipping-type-hidden");

	deactivateBtns();

	shippingTypeHidden.val(shippingType);
	let closestEl =  signatureOptionsSelect.data('target-closest');
	let closestParentEl = signatureOptionsSelect.closest(closestEl);
	function handleSignatureOptionEnable(el) {
		signatureOptionsSelect.attr("disabled", false);
		el.find(".select2-container").css("pointer-events",'');

	}
	function handleSignatureOptionDisable(el) {
		signatureOptionsSelect.attr("disabled", true);
		el.find(".select2-container").css("pointer-events",'none');

	}

	function fedexShippingSelected() {
  		shippingMethodUsaSelect.show();
		fedexShippingMethodBtn.addClass("active");
		serviceLevelsBtn.removeClass("active");
		serviceLevelUsaSelect.hide();
		btnClickVar=true;
		estimatedDeliveryDate.hide();
		serviceLevelsBtnValueCheck.val(false);
		serviceLevelsMessage.hide();
		$("#saturday-delivery-checkbox1").show();
	
  	}

	function serviceLevelsSelected(){
  		shippingMethodUsaSelect.hide();
		fedexShippingMethodBtn.removeClass("active");
		serviceLevelsBtn.addClass("active");
		serviceLevelUsaSelect.show();
		btnClickVar=true;
		estimatedDeliveryDate.show();
		fedexShippingMethodBtnValueCheck.val(false);
		serviceLevelsMessage.show();
		estimatedDeliveryDate.show();
		serviceLevelsMessage.show();
		$("#saturday-delivery-checkbox1").hide();
  	}

	if(fedexShippingMethodBtnValueCheck.val()=="true"){
		fedexShippingSelected();
	}

	if(serviceLevelsBtnValueCheck.val()=="true"){
		serviceLevelsSelected();
	}

	fedexShippingMethodBtn.on("click", function(e){
		fedexShippingSelected();
	});


	serviceLevelsBtn.on("click", function(e){
		serviceLevelsSelected();
	});

	function deactivateBtns(){
		serviceLevelsBtn.removeClass("active");
		fedexShippingMethodBtn.removeClass("active");
	}


	if(shippingType == "-1"){
		shippingMethodUsa.hide();
		shippingMethodCanada.hide();
		shippingMethodOther.hide();
		shippingMethodLtlMsg.hide();
		shippingMethodParcelMsg.hide();
		internationalProductShippingCost.hide();
		selectMethod.hide();
	}
	else if(shippingType == "PCL"){
		if(countryVal == "1"){
			var serviceLevelslength = serviceLevelsUsaId.children('option').length;
			if(serviceLevelslength == 0){ //No serviceLevel data
				fedexShippingMethodBtn.trigger('click');
				shippingMethodLtlMsg.hide();
				selectMethod.hide();
				shippingMethodParcelMsg.hide();
			}else{
				selectMethod.show();
				shippingMethodUsa.show();
				shippingMethodCanada.hide();
				shippingMethodOther.hide();
				internationalProductShippingCost.hide();
				shippingMethodLtlMsg.hide();
				shippingMethodParcelMsg.show();
				dontShowSectionForParcelSelection.hide();
			}
		}else if(countryVal == "2"){
				selectMethod.show();
				shippingMethodUsa.hide();
				shippingMethodCanada.show();
				shippingMethodOther.hide();
				shippingMethodUsaSelect.hide();
				serviceLevelUsaSelect.hide();
				estimatedDeliveryDate.hide();
				serviceLevelsMessage.hide();
				internationalProductShippingCost.show();
				shippingMethodLtlMsg.hide();
		}
		else{
			selectMethod.show();
			internationalProductShippingCost.show();
			shippingMethodUsa.hide();
			shippingMethodCanada.hide();
			shippingMethodOther.show();
			shippingMethodUsaSelect.hide();
			serviceLevelUsaSelect.hide();
			estimatedDeliveryDate.hide();
			serviceLevelsMessage.hide();
			shippingMethodLtlMsg.hide();
		}

	}
	else {
		shippingMethodUsa.hide();
		shippingMethodCanada.hide();
		shippingMethodOther.hide();
		internationalProductShippingCost.hide();
		shippingMethodLtlMsg.show();
		selectMethod.hide();
		shippingMethodParcelMsg.hide();
		shippingMethodUsaSelect.hide();
		serviceLevelUsaSelect.hide();
		serviceLevelsBtnValueCheck.val(false);
		fedexShippingMethodBtnValueCheck.val(false);
		estimatedDeliveryDate.hide();
		serviceLevelsMessage.hide();
		handleSignatureOptionDisable(closestParentEl);
		saturdayDeliveryCheckbox.attr("disabled",true);


	}

}

export function resetAccessorialSection() {
	const shippingMethodUsaId = $("#shipping-tab-shipping-method-with-usa");
	const signatureOptionsSelect = $("#signature-options-select");
	const shippingTabAccessorialeNote = $("#shipping-tab-accessorials-signature");
	const saturdayDeliveryCheckbox = $("#saturday-delivery-checkbox");
	const internationalShippingCosts = $(".international-product-shipping-container");
	let countryVal = $('#destination-tab-country  :selected').val();

	shippingMethodUsaId.val("-1").trigger("change.select2");
	signatureOptionsSelect.empty();
	shippingTabAccessorialeNote.html("");
	
	saturdayDeliveryCheckbox.prop("checked", false);
	saturdayDeliveryCheckbox.prop("disabled", true);

	internationalShippingCosts.find(':input[type="number"]').each(function () {
		if (countryVal === "1") {
			$(this).val("");
		}
	})
}



// WEBPACK FOOTER //
// ./src/pages/order/preparationTab.js